import { Component, OnInit } from '@angular/core';
import { AppFrameContextService, AppServerAPI, CommonBrowserStorageService, DialogService } from '@sdbn/common';
import { AreaGateReference, GateKeepingCase } from '../../gate-keeping.model';
import { GKCFindElementDialogComponent } from './gkc-find-element-dialog/gkc-find-element-dialog.component';
import { GKCSelectGateDialogComponent } from './gkc-select-gate-dialog/gkc-select-gate-dialog.component';

@Component({
    selector: 'app-gate-keeper-control',
    templateUrl: './gate-keeper-control.component.html',
    styleUrls: ['./gate-keeper-control.component.scss'],
    standalone: false
})
export class GateKeeperControlComponent implements OnInit {

  gateKeepingCase: GateKeepingCase;
  areaGateReference: AreaGateReference;

  taskMetaData: any;

  declineLabelEntrance = 'tmc-common.gate-keeping.ui.gate-keeper-control.decline-entrance';
  confirmLabelEntrance = 'tmc-common.gate-keeping.ui.gate-keeper-control.confirm-entrance';
  declineLabelLeave = 'tmc-common.gate-keeping.ui.gate-keeper-control.decline-leave';
  confirmLabelLeave = 'tmc-common.gate-keeping.ui.gate-keeper-control.confirm-leave';
  declineLabel = this.declineLabelEntrance;
  confirmLabel = this.confirmLabelEntrance;

  constructor(
    private dialogService: DialogService,
    private commonBrowserStorageService: CommonBrowserStorageService,
    private appFrameContextService: AppFrameContextService,
    private appServerAPI: AppServerAPI
  ) {

  }

  ngOnInit(): void {

    let gateId = this.commonBrowserStorageService.get(this.appFrameContextService.tenant.value?.key, 'gate-keeper-control', 'gate-id');
    let direction = this.commonBrowserStorageService.get(this.appFrameContextService.tenant.value?.key, 'gate-keeper-control', 'direction');

    if (direction === 'IN') {
      this.declineLabel = this.declineLabelEntrance;
      this.confirmLabel = this.confirmLabelEntrance;
    } else {
      this.declineLabel = this.declineLabelLeave;
      this.confirmLabel = this.confirmLabelLeave;
    }

    if (gateId != null && direction != null) {
      this.appServerAPI.execute<Array<AreaGateReference>>('/tmc-common/gate-keeper-app/getAllGates', null).subscribe(response => {
        for (let entry of response) {
          if (entry.id === gateId) {
            this.areaGateReference = new AreaGateReference(entry);
            this.areaGateReference.direction = direction;
          }
        }
      });
    }

  }

  private createTaskMetaData() {
    this.taskMetaData = {
      source: this.gateKeepingCase?.candidate?.source,
      sourceId: this.gateKeepingCase?.candidate?.sourceId,
      gateId: this.areaGateReference?.id,
      direction: this.areaGateReference?.direction,
    };
  }

  public openFindElementDialog() {
    this.dialogService.openMaxHeight(GKCFindElementDialogComponent, { areaGateReference: this.areaGateReference }).afterClosed().subscribe(result => {
      if (result != null) {
        this.appServerAPI.execute<GateKeepingCase>('/tmc-common/gate-keeper-app/getCase', {
          candidate: result,
          gateId: this.areaGateReference?.id,
          direction: this.areaGateReference?.direction
        }).subscribe(response => {
          this.gateKeepingCase = new GateKeepingCase(response);
          this.createTaskMetaData();
        });
      }
    });
  }

  public openSelectGateDialog() {
    this.dialogService.openMaxHeight(GKCSelectGateDialogComponent, null).afterClosed().subscribe(result => {
      if (result != null) {
        this.areaGateReference = result;
        this.commonBrowserStorageService.setPersistent(this.appFrameContextService.tenant.value?.key, 'gate-keeper-control', 'gate-id', result.id);
        this.commonBrowserStorageService.setPersistent(this.appFrameContextService.tenant.value?.key, 'gate-keeper-control', 'direction', result.direction);

        if (result.direction === 'IN') {
          this.declineLabel = this.declineLabelEntrance;
          this.confirmLabel = this.confirmLabelEntrance;
        } else {
          this.declineLabel = this.declineLabelLeave;
          this.confirmLabel = this.confirmLabelLeave;
        }
      }
    });
  }

  public confirm() {
    this.appServerAPI.execute<GateKeepingCase>('/tmc-common/gate-keeper-app/registerEntranceLeave', {
      candidate: this.gateKeepingCase.candidate,
      gateId: this.areaGateReference?.id,
      direction: this.areaGateReference?.direction
    }).subscribe(response => {
      this.gateKeepingCase = null;
    });
  }

  public decline() {
    this.appServerAPI.execute<GateKeepingCase>('/tmc-common/gate-keeper-app/declineEntranceLeave', {
      candidate: this.gateKeepingCase.candidate,
      gateId: this.areaGateReference?.id,
      direction: this.areaGateReference?.direction
    }).subscribe(response => {
      this.gateKeepingCase = null;
    });
  }

  public onTaskChanged() {
    this.appServerAPI.execute<GateKeepingCase>('/tmc-common/gate-keeper-app/getCase', {
      candidate: this.gateKeepingCase.candidate,
      gateId: this.areaGateReference?.id,
      direction: this.areaGateReference?.direction
    }).subscribe(response => {
      this.gateKeepingCase = new GateKeepingCase(response);
    });
  }

  public handleCancel() {
    this.gateKeepingCase = null;
  }

}
